import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { icons } from '@config'
import { ViewHeader, Help, Card, Submit, Input, Select, useGet, useSubmit } from '@enkla-gui'

export default function TenantCreate() {
	const history = useHistory()
	var { register, post, getValues, error, loading, handleSubmit } = useSubmit({
		endpoint: 'api/tenant',
		success: res => history.push(`/tenant/${res.tenant.id}`)
	})

	const submit = handleSubmit(data => {
		data.organisation = data.organisation === 'true'
		post(data)
	})

	return (
		<>
			<ViewHeader
				title='Hyresgäst'
				icon={icons.tenant}
				subtitle='Skapa'
				return={{ link: `#!/tenant/overview`, title: 'Översikt' }}
			/>
			<Card
				buttons={{
					footer: [<Submit onSubmit={submit} text='Skapa' sending={loading} />]
				}}>
				<div class='row mb-3'>
					<Select
						controls={{ register }}
						name='organisation'
						label='Kundtyp'
						error={error}
						values={[
							{ key: 'Privatkund', value: false },
							{ key: 'Företagskund', value: true }
						]}
					/>
				</div>
				<div class='row mb-3'>
					<Input controls={{ register }} name='name' options={{ required: true }} label='Namn' error={error} />
					<Input controls={{ register }} name='identifier' options={{ required: true }} label='Pers/Org-nummer' error={error} />
				</div>
				<div class='row mb-3'>
					<Input controls={{ register }} name='phone' options={{ required: true }} label='Telefonnummer' error={error} />
					<Input controls={{ register }} name='email' options={{ required: false }} label='E-post' error={error} />
				</div>
				<div class='row'>
					<Input
						controls={{ register }}
						name='billing_email'
						options={{ required: false }}
						label='E-post (Fakturering)'
						placeholder='Kontakt-e-post används för fakturor om inget annat anges'
						error={error}
					/>
				</div>
				<div class='row mb-3 mt-4'>
					<Input controls={{ register }} name='address.address' options={{ required: true }} label='Adress' error={error} />
					<Input controls={{ register }} name='address.postal_code' options={{ required: true }} label='Postnummer' error={error} />
				</div>
				<div class='row'>
					<Input controls={{ register }} name='address.city' options={{ required: true }} label='Stad' error={error} />
					<Select
						controls={{ register }}
						name='address.country'
						options={{ required: true }}
						label='Land'
						error={error}
						preset="countries"
					/>
				</div>
			</Card>
		</>
	)
}
